import type { AuthenticatedEverything } from '@/models'
import { apiClient } from '../../client'

export interface SignInOTLRequest {
  credential: string
  containingURL: string
}

export function otlLogin(
  signInOTLRequest: SignInOTLRequest
): Promise<AuthenticatedEverything> {
  return apiClient
    .post('v1/i/signIn/clientOTL', {
      json: signInOTLRequest
    })
    .then(response => response.json())
}
